import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    margin: ", "px 0;\n    max-width: ", "px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    margin-left: ", "px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    margin-left: ", "px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: -2px;\n    height: 2px;\n    background-color: ", ";\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-grow: 1;\n    align-items: stretch;\n    justify-content: ", ";\n    overflow: hidden;\n    height: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    position: relative;\n    border-bottom: 2px solid\n        ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { useUncontrolled } from './useUncontrolled';
import { noop } from '../helpers';
import { transitions } from '../mixins';
import { Button } from '../Button';
import { Balloon, useBalloon } from '../Balloon';
import { List, ListItem } from '../List';

function alignment(_ref) {
  var align = _ref.align;

  switch (align) {
    case 'right':
      return 'flex-end';

    case 'center':
      return 'center';

    case 'justify':
      return 'space-between';

    default:
      return 'flex-start';
  }
}

var StyledTabs = styled.div(_templateObject(), function (_ref2) {
  var disableIndicator = _ref2.disableIndicator,
      underlined = _ref2.underlined,
      theme = _ref2.theme;
  return disableIndicator || !underlined ? 'transparent' : theme.palette.gray.gray100;
});
var TabsContainer = styled.div(_templateObject2(), alignment, function (_ref3) {
  var theme = _ref3.theme;
  return theme.unit * 10 + 2;
});
var TabIndicator = styled.div(_templateObject3(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.primary.main;
}, transitions(['width', 'left']).easeInOut().standard());
var ExtraContent = styled.div(_templateObject4(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.unit * 5;
});
var ShowMoreButton = styled(Button)(_templateObject5(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.unit * 9;
});
var ShowMoreContainer = styled.div(_templateObject6());
var InvisibleTabsList = styled(List)(_templateObject7(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.unit * 2;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.unit * 60;
});

function useIndicatorPosition(currentValue, children) {
  var indicatorRef = useRef(null);
  var selectedTabRef = useRef(null);

  function setIndicatorParams(event) {
    if (!indicatorRef.current) {
      return;
    }

    if (event) {
      indicatorRef.current.style.transition = 'none';
    }

    var tabElement = ReactDOM.findDOMNode(selectedTabRef.current);
    var offset = tabElement ? tabElement.offsetLeft : 0;
    var width = tabElement ? tabElement.offsetWidth : 0;
    indicatorRef.current.style.width = "".concat(width, "px");
    indicatorRef.current.style.left = "".concat(offset, "px");

    if (event) {
      indicatorRef.current.style.transition = '';
    }
  }

  useEffect(function () {
    window.addEventListener('resize', setIndicatorParams);
    return function () {
      window.removeEventListener('resize', setIndicatorParams);
    };
  }, []);
  useEffect(function () {
    document.fonts.ready.finally(function () {
      return setIndicatorParams();
    });
  }, [currentValue, children]);
  return {
    indicatorRef: indicatorRef,
    selectedTabRef: selectedTabRef
  };
}

function useTabsOverflow() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tabsContainerRef = useRef(null);
  var showMoreRef = useRef(null);

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      splitIndex = _useState2[0],
      setSplitIndex = _useState2[1];

  var meta = useRef({
    container: 0,
    tabs: []
  });
  var childrenLength = React.Children.count(children);

  function setIndex() {
    if (!tabsContainerRef.current) {
      return;
    }

    var containerWidth = tabsContainerRef.current.clientWidth;
    var index = meta.current.tabs.findIndex(function (_ref9) {
      var totalWidth = _ref9.totalWidth;
      return totalWidth > containerWidth;
    });

    if (index !== -1 && showMoreRef.current && showMoreRef.current.hidden && meta.current.tabs[index - 1] && meta.current.tabs[index - 1].totalWidth > containerWidth - 81) {
      index -= 1;
    }

    setSplitIndex(index);
  }

  useLayoutEffect(function () {
    window.addEventListener('resize', setIndex);
    return function () {
      window.removeEventListener('resize', setIndex);
    };
  }, []);
  useLayoutEffect(function () {
    setSplitIndex(-1);
    document.fonts.ready.finally(function () {
      var _a;

      var totalWidth = 0;
      var tabs = Array.from(((_a = tabsContainerRef.current) === null || _a === void 0 ? void 0 : _a.children) || []);
      meta.current.tabs = tabs.map(function (tabElement) {
        var computedStyleMap = tabElement.computedStyleMap();
        var width = Math.ceil(tabElement.getBoundingClientRect().width + (computedStyleMap.get('margin-left').value || 0) + (computedStyleMap.get('margin-right').value || 0));
        totalWidth += width;
        return {
          width: width,
          totalWidth: totalWidth
        };
      });
      setIndex();
    });
  }, [childrenLength]);
  return {
    tabsContainerRef: tabsContainerRef,
    showMoreRef: showMoreRef,
    splitIndex: splitIndex
  };
}

export var Tabs = React.forwardRef(function (_a, ref) {
  var children = _a.children,
      component = _a.component,
      value = _a.value,
      _a$initialValue = _a.initialValue,
      initialValue = _a$initialValue === void 0 ? 0 : _a$initialValue,
      _a$align = _a.align,
      align = _a$align === void 0 ? 'left' : _a$align,
      _a$disableIndicator = _a.disableIndicator,
      disableIndicator = _a$disableIndicator === void 0 ? false : _a$disableIndicator,
      _a$underlined = _a.underlined,
      underlined = _a$underlined === void 0 ? true : _a$underlined,
      extraContent = _a.extraContent,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? noop : _a$onChange,
      props = __rest(_a, ["children", "component", "value", "initialValue", "align", "disableIndicator", "underlined", "extraContent", "onChange"]);

  var tabsArray = React.Children.toArray(children);

  var _ref10 = value != null ? [value, onChange] : useUncontrolled(initialValue, onChange),
      _ref11 = _slicedToArray(_ref10, 2),
      currentValue = _ref11[0],
      setValue = _ref11[1];

  var _useBalloon = useBalloon(),
      isBalloonOpened = _useBalloon.isBalloonOpened,
      toggleBalloon = _useBalloon.toggleBalloon,
      closeBalloon = _useBalloon.closeBalloon;

  var _useTabsOverflow = useTabsOverflow(children),
      tabsContainerRef = _useTabsOverflow.tabsContainerRef,
      showMoreRef = _useTabsOverflow.showMoreRef,
      splitIndex = _useTabsOverflow.splitIndex;

  var _useIndicatorPosition = useIndicatorPosition(currentValue, children),
      indicatorRef = _useIndicatorPosition.indicatorRef,
      selectedTabRef = _useIndicatorPosition.selectedTabRef;

  var visibleTabs = splitIndex < 0 ? tabsArray : tabsArray.slice(0, splitIndex);
  var invisibleTabs = splitIndex < 0 || splitIndex >= tabsArray.length ? [] : tabsArray.slice(splitIndex);
  return React.createElement(StyledTabs, Object.assign({}, props, component && {
    as: component
  }, {
    ref: ref,
    disableIndicator: disableIndicator,
    underlined: underlined
  }), React.createElement(TabsContainer, {
    ref: tabsContainerRef,
    align: align
  }, visibleTabs.map(function (Child, index) {
    var value = Child.props.value || index;
    var isSelected = value === currentValue;
    return React.cloneElement(Child, {
      value: value,
      selected: isSelected,
      onClick: setValue,
      ref: isSelected ? selectedTabRef : undefined
    });
  })), !disableIndicator && React.createElement(TabIndicator, {
    ref: indicatorRef
  }), React.createElement(ShowMoreContainer, {
    ref: showMoreRef,
    hidden: !invisibleTabs.length
  }, React.createElement(Balloon, {
    opened: isBalloonOpened,
    onOutsideClick: closeBalloon,
    placement: 'bottom-end',
    content: React.createElement(InvisibleTabsList, null, invisibleTabs.map(function (tab, index) {
      var value = tab.props.value || visibleTabs.length + index;
      var isSelected = value === currentValue;
      return React.createElement(ListItem, Object.assign({}, tab.props.component && {
        as: tab.props.component
      }, tab.props.to && {
        to: tab.props.to
      }, {
        key: tab.key,
        selected: isSelected,
        onClick: function onClick() {
          setValue({
            target: {
              value: value
            }
          });
          setTimeout(closeBalloon, 100);
        }
      }), tab.props.children);
    }))
  }, function (_ref12) {
    var ref = _ref12.ref;
    return React.createElement(ShowMoreButton, {
      ref: ref,
      rounded: true,
      size: 'large',
      onClick: function onClick() {
        return toggleBalloon(null);
      }
    }, "+", invisibleTabs.length);
  })), extraContent && React.createElement(ExtraContent, null, extraContent));
});
Tabs.displayName = 'Tabs';